(function(){
  const CARD='.product-card[data-d2-adaptive]';
  const q=(c,s)=>c.querySelector(s),qa=(c,s)=>Array.from(c.querySelectorAll(s));
  function imgs(c){return qa(c,'figure picture img:not(.color-variant-img)')}
  function image(c,u){if(!u)return;imgs(c).forEach(i=>{if(!i.dataset.d2OriginalSrc)i.dataset.d2OriginalSrc=i.currentSrc||i.src;if(!i.dataset.d2OriginalSrcset&&i.getAttribute('srcset'))i.dataset.d2OriginalSrcset=i.getAttribute('srcset');i.src=u;i.removeAttribute('srcset')})}
  function restoreImage(c){imgs(c).forEach(i=>{if(i.dataset.d2OriginalSrc)i.src=i.dataset.d2OriginalSrc;if(i.dataset.d2OriginalSrcset)i.setAttribute('srcset',i.dataset.d2OriginalSrcset)})}
  function type(c){return +(q(c,'[data-d2qa]')?.dataset.d2Type||0)}
  function variants(c){try{return JSON.parse(q(c,'[data-d2-variants]')?.textContent||'[]')}catch(e){return[]}}
  function indexes(c){const r=q(c,'[data-d2qa]');return{color:+(r?.dataset.colorIndex??-1),size:+(r?.dataset.sizeIndex??-1)}}
  function variant(c,id){const value=id?String(id):'';const i=q(c,'[data-d2-variant-id]');if(i)i.value=value;c.dataset.d2SelectedVariant=value}
  function ready(c,on){const b=q(c,'[data-d2-add]');if(b)b.dataset.ready=on?'true':'false'}
  function selectedSize(c,s){qa(c,'[data-d2-size]').forEach(x=>{const on=x===s;x.classList.toggle('is-selected',on);x.setAttribute('aria-pressed',on?'true':'false')})}
  function selectedColor(c,col){qa(c,'.d2qa__swatch-input').forEach(x=>x.checked=false);if(!col)return;const radio=q(col,'.d2qa__swatch-input');if(radio)radio.checked=true}
  function type1Color(c,col){
    const root=q(c,'[data-d2qa]'),value=col.dataset.colorValue||'',vs=variants(c),ix=indexes(c);
    if(root)root.dataset.d2Color=value;
    selectedColor(c,col);image(c,col.dataset.img);
    qa(c,'[data-d2-size]').forEach(b=>{
      const ok=vs.some(v=>v.available&&v.options[ix.color]===value&&v.options[ix.size]===b.dataset.sizeValue);
      b.hidden=!ok;b.classList.remove('is-selected');b.setAttribute('aria-pressed','false');
    });
    variant(c,'');ready(c,false);
  }
  function type1Size(c,s){
    const root=q(c,'[data-d2qa]'),color=root?.dataset.d2Color||'',vs=variants(c),ix=indexes(c);
    if(s.classList.contains('is-selected')){selectedSize(c,null);variant(c,'');ready(c,false);return}
    if(!color)return;
    const v=vs.find(x=>x.available&&x.options[ix.color]===color&&x.options[ix.size]===s.dataset.sizeValue);
    if(!v)return;
    variant(c,v.id);selectedSize(c,s);ready(c,true);
  }
  async function add(c,b){
    if(b.dataset.ready!=='true')return;
    const i=q(c,'[data-d2-variant-id]'),id=(i&&i.value)||c.dataset.d2SelectedVariant||'';if(!id||b.disabled)return;
    b.disabled=true;b.setAttribute('aria-busy','true');
    try{
      const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})});
      if(!r.ok)throw new Error('Cart add failed: '+r.status);await r.json();
      const note=q(c,'[data-d2-added-note]');if(note){note.classList.add('is-visible');setTimeout(()=>note.classList.remove('is-visible'),1400)}
      try{const cr=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(cr.ok){const cart=await cr.json();document.querySelectorAll('[data-cart-count],.cart-count,.header-cart-count').forEach(el=>{el.textContent=cart.item_count;el.removeAttribute('hidden')})}}catch(_e){}
    }catch(err){console.error('DIVA Quick Add:',err)}finally{b.disabled=false;b.removeAttribute('aria-busy')}
  }
  document.addEventListener('click',e=>{
    const c=e.target.closest(CARD);if(!c)return;
    const s=e.target.closest('[data-d2-size]');
    if(s){
      e.preventDefault();e.stopPropagation();
      if(type(c)===1)type1Size(c,s);else if(s.classList.contains('is-selected')){selectedSize(c,null);variant(c,'');ready(c,false)}else{variant(c,s.dataset.variantId);selectedSize(c,s);ready(c,true)}
      return;
    }
    const col=e.target.closest('[data-d2-color]');
    if(col){
      e.preventDefault();e.stopPropagation();
      const radio=q(col,'.d2qa__swatch-input'),wasSelected=!!(radio&&radio.checked);
      if(wasSelected){
        selectedColor(c,null);variant(c,'');ready(c,false);restoreImage(c);
        if(type(c)===1){const root=q(c,'[data-d2qa]');if(root)root.dataset.d2Color='';selectedSize(c,null);qa(c,'[data-d2-size]').forEach(b=>b.hidden=false)}
      }else if(type(c)===1)type1Color(c,col);else{variant(c,col.dataset.variantId);image(c,col.dataset.img);selectedColor(c,col);ready(c,true)}
      return;
    }
    const buy=e.target.closest('[data-d2-add]');
    if(buy){e.preventDefault();e.stopPropagation();add(c,buy);return}
  },true);
  document.addEventListener('mouseover',e=>{const c=e.target.closest(CARD);if(!c)return;const col=e.target.closest('[data-d2-color]');if(col)image(c,col.dataset.img)});
  document.querySelectorAll(CARD).forEach(c=>ready(c,false));
})();
